import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer2WycinkaDrzew from "../../components/offer/2wycinkaDrzew";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Wycinka drzew pod inwestycje budowlane | Gdańsk, Gdynia, Kartuzy, Kaszuby</title>
        <meta name="title" content="Wycinka drzew pod inwestycje budowlane | Gdańsk, Gdynia, Kartuzy, Kaszuby" />
        <meta
          name="description"
          content="Karczowanie i wycinka kolidujących drzew przygotowująca teren pod nową budowę lub ogród. Realizujemy zlecenia w Gdańsku, Gdyni, Wejherowie i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Wycinka drzew pod inwestycje budowlane | Gdańsk, Gdynia, Kartuzy, Kaszuby"
        />
        <meta
          property="og:description"
          content="Karczowanie i wycinka kolidujących drzew przygotowująca teren pod nową budowę lub ogród. Realizujemy zlecenia w Gdańsku, Gdyni, Wejherowie i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer2WycinkaDrzew />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
